import { __ } from "@wordpress/i18n";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenu } from '../../contexts/MenuContext';
import withForm from '../../layouts/WithForm/WithForm';
import Switch from '../../components/Switch/Switch';
const Permission = ({handleChange}) => {
 const {settingData} = useMenu();
	return (
		<>
			<div className="content-section">
				<div className="leftSection">
					<h2 className="title header-1 primary-text-color semi-bold">
						{__("Permission", "access-control")}
					</h2>
					<p className="description header-2 primary-text-color regular">
						{__(
							"Allow the following user roles to view as customer.",
							"access-control",
						)}
					</p>
				</div>

				<div className="rightSection">
					<div className="setting-item">
						<div className="input-container">
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="shop-manager-tooltip">
										{__(
											"Enable or disable the Shop Manager role view.",
											"access-control",
										)}
									</Tooltip>
								}
							>
								<img
									src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
									alt="icon"
									className="icon"
									style={{ cursor: "pointer" }}
								/>
							</OverlayTrigger>

							<div className="input-field">
								<span className="setting-label header-1 primary-text-color semi-bold">
									{__("Shop Manager", "access-control")}
								</span>
								<Switch 
									name="global_settings.permission.enable_shop_manager"
									checked={settingData?.global_settings?.permission?.enable_shop_manager} 
									onChange={handleChange} 
								/>
							</div>
						</div>
						<div className="note header-2 primary-text-color regular">
							{__(
								"Allow the following user roles to view as customer.",
								"access-control",
							)}
						</div>
					</div>
				</div>
			</div>		
		</>
	);
};

export default withForm(Permission, 'global_settings.permission');